(function() {
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminSettingsController', AdminSettingsController);

    function AdminSettingsController(modulesService) {
        var vm = this;
        vm.contractsModuleEnabled = modulesService.isEnabled('contracts_module');
        vm.metersModuleEnabled = modulesService.isEnabled('meters_module');
        vm.spillagesModuleEnabled = modulesService.isEnabled('spillages_module');
        vm.assetsModuleEnabled = modulesService.isEnabled('assets_module');
    }
})();
